import { TRANSLATION_KEYS } from '../../translations'

import { renderTableProperties } from './helpers/renderTableProperties'
import { IApolloMatchColumn } from './models/apolloMatchColumn'

export const COLUMNS: IApolloMatchColumn[] = [
  {
    priority: 1,
    title: TRANSLATION_KEYS.tableColumns.name,
    field: 'communicationName',
    hideSettings: true,
    disableSort: true,
    renderFunction: (item, column) =>
      renderTableProperties({ item: item.partner, fieldName: column.field }),
  },
  {
    priority: 2,
    title: TRANSLATION_KEYS.tableColumns.partnerId,
    field: 'partnerId',
    hideSettings: true,
    disableSort: true,
    renderFunction: (item, column) =>
      renderTableProperties({ item: item.partner, fieldName: column.field }),
  },
  {
    priority: 3,
    title: TRANSLATION_KEYS.tableColumns.partnerType,
    field: 'partnerType',
    hideSettings: true,
    disableSort: true,
    renderFunction: (item, column) =>
      renderTableProperties({ item: item.partner, fieldName: column.field }),
  },
  {
    priority: 4,
    title: TRANSLATION_KEYS.tableColumns.hierarchy,
    field: 'hierarchyType',
    hideSettings: true,
    disableSort: true,
    renderFunction: (item, column) =>
      renderTableProperties({ item: item.partner, fieldName: column.field }),
  },
  {
    priority: 5,
    title: TRANSLATION_KEYS.tableColumns.country,
    field: 'country',
    hideSettings: true,
    disableSort: true,
    renderFunction: (item, column) =>
      renderTableProperties({ item: item.partner, fieldName: column.field }),
  },
  {
    priority: 6,
    title: TRANSLATION_KEYS.tableColumns.state,
    field: 'state',
    hideSettings: true,
    disableSort: true,
    renderFunction: (item, column) =>
      renderTableProperties({ item: item.partner, fieldName: column.field }),
  },
  {
    priority: 7,
    title: TRANSLATION_KEYS.tableColumns.city,
    field: 'city',
    hideSettings: true,
    disableSort: true,
    renderFunction: (item, column) =>
      renderTableProperties({ item: item.partner, fieldName: column.field }),
  },
  {
    priority: 8,
    title: TRANSLATION_KEYS.tableColumns.taxId,
    field: 'taxId',
    hideSettings: true,
    disableSort: true,
    renderFunction: (item, column) =>
      renderTableProperties({ item: item.partner, fieldName: column.field }),
  },
  {
    priority: 9,
    title: TRANSLATION_KEYS.tableColumns.postalCode,
    field: 'zipCode',
    hideSettings: true,
    disableSort: true,
    renderFunction: (item, column) =>
      renderTableProperties({ item: item.partner, fieldName: column.field }),
  },
  {
    priority: 10,
    title: TRANSLATION_KEYS.tableColumns.addressLine1,
    field: 'addressLine1',
    hideSettings: true,
    disableSort: true,
    renderFunction: (item, column) =>
      renderTableProperties({ item: item.partner, fieldName: column.field }),
  },
  {
    priority: 11,
    title: TRANSLATION_KEYS.tableColumns.addressLine2,
    field: 'addressLine2',
    hideSettings: true,
    disableSort: true,
    renderFunction: (item, column) =>
      renderTableProperties({ item: item.partner, fieldName: column.field }),
  },
  {
    priority: 12,
    title: TRANSLATION_KEYS.tableColumns.addressLine3,
    field: 'addressLine3',
    hideSettings: true,
    disableSort: true,
    renderFunction: (item, column) =>
      renderTableProperties({ item: item.partner, fieldName: column.field }),
  },
]
